// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color de marca XTAM (#A61B34) — roles */
.roles-page {
  --roles-primary: #a61b34;
  --roles-primary-hover: #861a2e;
  --roles-primary-muted: rgba(166, 27, 52, 0.35);
  --roles-primary-border: rgba(166, 27, 52, 0.28);
  --roles-primary-bg-soft: rgba(166, 27, 52, 0.08);
  --roles-primary-bg-selected: rgba(166, 27, 52, 0.12);

  flex: 1 1;
  padding: 24px 28px 32px;
  background: #141414;
  color: #f4f4f5;
  min-height: 100%;
  box-sizing: border-box;
}

.roles-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.roles-header-text h1 {
  margin: 0 0 8px;
  font-size: 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.roles-title-icon {
  color: var(--roles-primary);
  flex-shrink: 0;
}

.roles-subtitle {
  margin: 0;
  color: #a1a1aa;
  font-size: 0.95rem;
}

.roles-save-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border: 1px solid var(--roles-primary);
  border-radius: 8px;
  background: var(--roles-primary);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 0 0 1px rgba(166, 27, 52, 0.25);
}

.roles-save-btn:hover:not(:disabled) {
  background: var(--roles-primary-hover);
  border-color: var(--roles-primary-hover);
  box-shadow: 0 0 0 1px rgba(166, 27, 52, 0.4);
}

.roles-save-btn svg {
  color: #fff;
  flex-shrink: 0;
}

.roles-save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.roles-layout {
  display: grid;
  grid-template-columns: minmax(240px, 300px) 1fr;
  gap: 24px;
  align-items: start;
}

@media (max-width: 900px) {
  .roles-layout {
    grid-template-columns: 1fr;
  }
}

.roles-sidebar {
  background: #1c1c1c;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid var(--roles-primary-border);
}

.roles-sidebar-title {
  margin: 0 0 12px;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a1a1aa;
}

.roles-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.roles-card {
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border-radius: 10px;
  border: 2px solid transparent;
  background: #252525;
  color: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.roles-card:hover {
  background: #2e2e2e;
  border-color: var(--roles-primary-muted);
}

.roles-card.selected {
  border-color: var(--roles-primary);
  background: rgba(42, 32, 32, 0.95);
  box-shadow: 0 0 0 1px var(--roles-primary-bg-soft);
}

.roles-card-name {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}

.roles-card-desc {
  display: block;
  font-size: 0.8rem;
  color: #a1a1aa;
}

.roles-detail {
  background: #1c1c1c;
  border-radius: 12px;
  padding: 20px 22px;
  border: 1px solid var(--roles-primary-border);
}

.roles-muted {
  color: #71717a;
  margin: 0;
}

.roles-detail-head {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--roles-primary-border);
}

.roles-detail-role-name {
  display: inline-block;
  padding: 8px 14px;
  border-radius: 8px;
  border: 2px solid var(--roles-primary);
  font-weight: 600;
  margin-bottom: 10px;
  background: var(--roles-primary-bg-soft);
  color: #fafafa;
}

.roles-detail-summary {
  margin: 0;
  color: #a1a1aa;
  font-size: 0.9rem;
  line-height: 1.45;
}

.roles-accordion {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.roles-acc-item {
  border-radius: 10px;
  background: #252525;
  border: 1px solid var(--roles-primary-border);
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.roles-acc-item:has(.roles-acc-body) {
  border-color: var(--roles-primary-muted);
  box-shadow: inset 0 0 0 1px var(--roles-primary-bg-soft);
}

.roles-acc-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  font-size: 1rem;
  text-align: left;
}

.roles-acc-header:hover {
  background: var(--roles-primary-bg-soft);
}

.roles-acc-icon {
  display: flex;
  color: var(--roles-primary);
  opacity: 1;
}

.roles-acc-icon svg {
  color: inherit;
}

.roles-acc-label {
  flex: 1 1;
  font-weight: 500;
}

.roles-acc-chevron {
  color: var(--roles-primary-muted);
  transition: transform 0.2s ease, color 0.2s ease;
}

.roles-acc-chevron.open {
  transform: rotate(-180deg);
  color: var(--roles-primary);
}

.roles-acc-body {
  padding: 0 16px 16px 52px;
  border-top: 1px solid var(--roles-primary-border);
  background: rgba(0, 0, 0, 0.12);
}

.roles-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  font-size: 0.92rem;
}

.roles-toggle-row.sub {
  padding-left: 8px;
  color: #d4d4d8;
}

.roles-subactions {
  border-top: 1px solid var(--roles-primary-border);
  margin-top: 4px;
  padding-top: 4px;
}

/* Interruptor tipo switch (reemplaza checkbox) */
.roles-switch-btn {
  position: relative;
  flex-shrink: 0;
  width: 48px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 999px;
}

.roles-switch-btn:focus {
  outline: none;
}

.roles-switch-btn:focus-visible .roles-switch-track {
  outline: 2px solid var(--roles-primary);
  outline-offset: 3px;
  box-shadow: 0 0 0 2px var(--roles-primary-bg-selected);
}

.roles-switch-track {
  display: block;
  width: 48px;
  height: 28px;
  border-radius: 999px;
  background: #3f3f46;
  transition: background 0.2s ease;
  position: relative;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.35);
}

.roles-switch-btn--on .roles-switch-track {
  background: var(--roles-primary);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(166, 27, 52, 0.35);
}

.roles-switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fafafa;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease;
}

.roles-switch-btn--on .roles-switch-thumb {
  transform: translateX(20px);
}

/* Restricción de horas de previsualización */
.roles-max-hours-section {
  border-top: 1px solid var(--roles-primary-border);
  margin-top: 8px;
  padding-top: 8px;
}

.roles-max-hours-input-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 8px 4px;
}

.roles-max-hours-label {
  font-size: 0.85rem;
  color: #d4d4d8;
  font-weight: 500;
}

.roles-max-hours-input {
  width: 100px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--roles-primary-border);
  background: #1c1c1c;
  color: #f4f4f5;
  font-size: 0.9rem;
  font-variant-numeric: tabular-nums;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.roles-max-hours-input:focus {
  outline: none;
  border-color: var(--roles-primary);
  box-shadow: 0 0 0 2px var(--roles-primary-bg-soft);
}

.roles-max-hours-hint {
  font-size: 0.8rem;
  color: #a1a1aa;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/pages/RolesPage.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,8CAA8C;EAC9C,+CAA+C;EAC/C,gDAAgD;EAChD,oDAAoD;;EAEpD,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iFAAiF;EACjF,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,wCAAwC;EACxC,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C;EACE,iDAAiD;EACjD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Color de marca XTAM (#A61B34) — roles */\n.roles-page {\n  --roles-primary: #a61b34;\n  --roles-primary-hover: #861a2e;\n  --roles-primary-muted: rgba(166, 27, 52, 0.35);\n  --roles-primary-border: rgba(166, 27, 52, 0.28);\n  --roles-primary-bg-soft: rgba(166, 27, 52, 0.08);\n  --roles-primary-bg-selected: rgba(166, 27, 52, 0.12);\n\n  flex: 1;\n  padding: 24px 28px 32px;\n  background: #141414;\n  color: #f4f4f5;\n  min-height: 100%;\n  box-sizing: border-box;\n}\n\n.roles-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.roles-header-text h1 {\n  margin: 0 0 8px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.roles-title-icon {\n  color: var(--roles-primary);\n  flex-shrink: 0;\n}\n\n.roles-subtitle {\n  margin: 0;\n  color: #a1a1aa;\n  font-size: 0.95rem;\n}\n\n.roles-save-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border: 1px solid var(--roles-primary);\n  border-radius: 8px;\n  background: var(--roles-primary);\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n  box-shadow: 0 0 0 1px rgba(166, 27, 52, 0.25);\n}\n\n.roles-save-btn:hover:not(:disabled) {\n  background: var(--roles-primary-hover);\n  border-color: var(--roles-primary-hover);\n  box-shadow: 0 0 0 1px rgba(166, 27, 52, 0.4);\n}\n\n.roles-save-btn svg {\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.roles-save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.roles-layout {\n  display: grid;\n  grid-template-columns: minmax(240px, 300px) 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 900px) {\n  .roles-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.roles-sidebar {\n  background: #1c1c1c;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid var(--roles-primary-border);\n}\n\n.roles-sidebar-title {\n  margin: 0 0 12px;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #a1a1aa;\n}\n\n.roles-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.roles-card {\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 2px solid transparent;\n  background: #252525;\n  color: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.roles-card:hover {\n  background: #2e2e2e;\n  border-color: var(--roles-primary-muted);\n}\n\n.roles-card.selected {\n  border-color: var(--roles-primary);\n  background: rgba(42, 32, 32, 0.95);\n  box-shadow: 0 0 0 1px var(--roles-primary-bg-soft);\n}\n\n.roles-card-name {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.roles-card-desc {\n  display: block;\n  font-size: 0.8rem;\n  color: #a1a1aa;\n}\n\n.roles-detail {\n  background: #1c1c1c;\n  border-radius: 12px;\n  padding: 20px 22px;\n  border: 1px solid var(--roles-primary-border);\n}\n\n.roles-muted {\n  color: #71717a;\n  margin: 0;\n}\n\n.roles-detail-head {\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--roles-primary-border);\n}\n\n.roles-detail-role-name {\n  display: inline-block;\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 2px solid var(--roles-primary);\n  font-weight: 600;\n  margin-bottom: 10px;\n  background: var(--roles-primary-bg-soft);\n  color: #fafafa;\n}\n\n.roles-detail-summary {\n  margin: 0;\n  color: #a1a1aa;\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.roles-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.roles-acc-item {\n  border-radius: 10px;\n  background: #252525;\n  border: 1px solid var(--roles-primary-border);\n  overflow: hidden;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.roles-acc-item:has(.roles-acc-body) {\n  border-color: var(--roles-primary-muted);\n  box-shadow: inset 0 0 0 1px var(--roles-primary-bg-soft);\n}\n\n.roles-acc-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: transparent;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  font-size: 1rem;\n  text-align: left;\n}\n\n.roles-acc-header:hover {\n  background: var(--roles-primary-bg-soft);\n}\n\n.roles-acc-icon {\n  display: flex;\n  color: var(--roles-primary);\n  opacity: 1;\n}\n\n.roles-acc-icon svg {\n  color: inherit;\n}\n\n.roles-acc-label {\n  flex: 1;\n  font-weight: 500;\n}\n\n.roles-acc-chevron {\n  color: var(--roles-primary-muted);\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.roles-acc-chevron.open {\n  transform: rotate(-180deg);\n  color: var(--roles-primary);\n}\n\n.roles-acc-body {\n  padding: 0 16px 16px 52px;\n  border-top: 1px solid var(--roles-primary-border);\n  background: rgba(0, 0, 0, 0.12);\n}\n\n.roles-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 0;\n  font-size: 0.92rem;\n}\n\n.roles-toggle-row.sub {\n  padding-left: 8px;\n  color: #d4d4d8;\n}\n\n.roles-subactions {\n  border-top: 1px solid var(--roles-primary-border);\n  margin-top: 4px;\n  padding-top: 4px;\n}\n\n/* Interruptor tipo switch (reemplaza checkbox) */\n.roles-switch-btn {\n  position: relative;\n  flex-shrink: 0;\n  width: 48px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 999px;\n}\n\n.roles-switch-btn:focus {\n  outline: none;\n}\n\n.roles-switch-btn:focus-visible .roles-switch-track {\n  outline: 2px solid var(--roles-primary);\n  outline-offset: 3px;\n  box-shadow: 0 0 0 2px var(--roles-primary-bg-selected);\n}\n\n.roles-switch-track {\n  display: block;\n  width: 48px;\n  height: 28px;\n  border-radius: 999px;\n  background: #3f3f46;\n  transition: background 0.2s ease;\n  position: relative;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.35);\n}\n\n.roles-switch-btn--on .roles-switch-track {\n  background: var(--roles-primary);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(166, 27, 52, 0.35);\n}\n\n.roles-switch-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fafafa;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);\n  transition: transform 0.2s ease;\n}\n\n.roles-switch-btn--on .roles-switch-thumb {\n  transform: translateX(20px);\n}\n\n/* Restricción de horas de previsualización */\n.roles-max-hours-section {\n  border-top: 1px solid var(--roles-primary-border);\n  margin-top: 8px;\n  padding-top: 8px;\n}\n\n.roles-max-hours-input-row {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 8px 4px;\n}\n\n.roles-max-hours-label {\n  font-size: 0.85rem;\n  color: #d4d4d8;\n  font-weight: 500;\n}\n\n.roles-max-hours-input {\n  width: 100px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--roles-primary-border);\n  background: #1c1c1c;\n  color: #f4f4f5;\n  font-size: 0.9rem;\n  font-variant-numeric: tabular-nums;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.roles-max-hours-input:focus {\n  outline: none;\n  border-color: var(--roles-primary);\n  box-shadow: 0 0 0 2px var(--roles-primary-bg-soft);\n}\n\n.roles-max-hours-hint {\n  font-size: 0.8rem;\n  color: #a1a1aa;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
